import {CrossModelComparisonTables} from './CrossModelValidation';

/**
 * Filters the cross model comparison tables to only show rows with mismatches if requested.
 * A row is considered a mismatch if any of its cells have errors or user edits.
 */
export function filterMismatchRows(
  tables: CrossModelComparisonTables,
  hideMatchingRows: boolean
): CrossModelComparisonTables {
  if (!hideMatchingRows) {
    return tables;
  }

  const filteredTable = tables.primaryTable.filter((row) => row.some((cell) => cell.error));

  return {
    ...tables,
    primaryTable: filteredTable,
  };
}
